import type { FeatureFlagKeys } from "types/feature-flags";
import { useCallback } from "react";
import FeatureFlagService from "services/FeatureFlagService";
import useFeatureFlagStatus from "../useFeatureFlagStatus";

/**
 * Call it with a flag key to get the resolved value, or without arguments to get a checker function.
 */
function useFeatureFlag(): (flagKey: FeatureFlagKeys) => boolean;
function useFeatureFlag(flagKey: FeatureFlagKeys): boolean;
function useFeatureFlag(flagKey?: FeatureFlagKeys) {
  const status = useFeatureFlagStatus();

  const check = useCallback(
    (key: FeatureFlagKeys) => {
      if (status === "fetching") return false;
      return FeatureFlagService.isEnabled(key);
    },
    [status]
  );

  if (typeof flagKey !== "undefined") return check(flagKey);

  return check;
}

export default useFeatureFlag;
